"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkCommentDialog = exports.SingleCommentingDialog = void 0;
var single_commenting_dialog_1 = require("./single-commenting-dialog");
Object.defineProperty(exports, "SingleCommentingDialog", { enumerable: true, get: function () { return single_commenting_dialog_1.SingleCommentingDialog; } });
var bulk_comment_dialog_1 = require("./bulk-comment-dialog");
Object.defineProperty(exports, "BulkCommentDialog", { enumerable: true, get: function () { return bulk_comment_dialog_1.BulkCommentDialog; } });
